import {observer} from 'mobx-react';
import React from 'react';
import {Button} from 'antd';
import * as moment from 'moment';
import classNames from 'classnames';
import {FlagButton} from '../../../common/flag-button';
import {CheckButton} from '../../../common/check-button';
import {EditableField} from '../../../common/editable-field';
import {PhoneNumber} from '../../../common/phone-number';

@observer
export class LeadItem extends React.Component {

  commentTextareaRef = new React.createRef();

  render() {
    const { lead } = this.props;

    const { data } = lead;

    const className = classNames(
      'lead-item',
      'lead-item--' + (data.read ? 'read' : 'unread'),
      data.important ? 'lead-item--important' : ''
    );

    return (
      <div className={className}>
        <div className="lead--status">
          {this.formatStatus(data)}
        </div>
        <div className="lead--date">{this.formatDate(data.date)}</div>
        <div className="lead--source">{this.formatSource(data.source)}</div>
        <div className="lead--client">{data.name}</div>
        <div className="lead--phone"><PhoneNumber phone={data.phone}/></div>
        <div className="lead--form">{this.formatFormName(data.formName)}</div>
        <div className="lead--message">{data.message}</div>
        <div className="lead--comment">
          <EditableField
            value={data.comment}
            saving={lead.isUpdatingComment}
            editing={lead.isEditingComment}

            onStartEdit={this.startEditComment}
            onSave={this.saveComment}
            onCancel={this.stopEditComment}
          />
        </div>
        <div className="lead--actions">
          <Button type="link" loading={lead.isRemoving} onClick={() => lead.remove()}>Удалить</Button>
        </div>
      </div>
    );
  }

  startEditComment = () => {
    this.props.lead.startEditComment();
  }
  stopEditComment = () => {
    this.props.lead.stopEditComment();
  }

  saveComment = (value) => {
    this.props.lead.updateComment(value);
  }

  formatDate(date) {
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
  }

  formatSource(source) {
    source = (source || '').replace(/http?s:\/\//, '');
    let i = source.indexOf('/');
    if (i > -1) {
      source = source.slice(0, i);
    }
    return source;
  }

  formatStatus(data) {
    const { lead } = this.props;

    return (
      <div>
        <FlagButton enabled={data.important} onChange={imp => lead.updateImportant(imp)} />
        <CheckButton enabled={data.read} onChange={read => lead.updateRead(read)} />
      </div>
    );
  }

  formatFormName(formName) {
    if (formName === 'popup-zakaz') {
      return 'заказ пропуска';
    }

    return formName;
  }

}




// WEBPACK FOOTER //
// ./src/components/pages/crm/lead/lead-item.js